/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NarrativeType = {
    Related: 'related',
    Sentiment: 'sentiment',
    Stance: 'stance'
} as const;
export type NarrativeType = typeof NarrativeType[keyof typeof NarrativeType];


export function instanceOfNarrativeType(value: any): boolean {
    for (const key in NarrativeType) {
        if (Object.prototype.hasOwnProperty.call(NarrativeType, key)) {
            if (NarrativeType[key as keyof typeof NarrativeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NarrativeTypeFromJSON(json: any): NarrativeType {
    return NarrativeTypeFromJSONTyped(json, false);
}

export function NarrativeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NarrativeType {
    return json as NarrativeType;
}

export function NarrativeTypeToJSON(value?: NarrativeType | null): any {
    return value as any;
}

export function NarrativeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): NarrativeType {
    return value as NarrativeType;
}

